import i18n from "i18next";
import enTranslation from "./en/translation.json";
import { initReactI18next } from "react-i18next";
import hiTranslation from "./hi/translation.json";
import mrTranslation from "./mr/translation.json";
import LanguageDetector from "i18next-browser-languagedetector";

export const resources = {
  en: {
    translation: enTranslation,
  },
  hi: {
    translation: hiTranslation,
  },
  mr: {
    translation: mrTranslation,
  },
} as const;

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources,
  });
